import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CourseDetail from "../pages/course-detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/curso/:id",
    element: <CourseDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
